import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Dashboard from './pages/admin/Dashboard';
import BusinessCollection from './pages/admin/BusinessCollection';
import ClientManagement from './pages/admin/ClientManagement';
import SystemManagement from './pages/admin/SystemManagement';
import LicenseManagement from './pages/admin/LicenseManagement';
import BusinessLogViewer from './pages/admin/BusinessLogViewer';
import PaymentManagement from './pages/admin/PaymentManagement';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';

// Main Layout Component
const AdminLayout = () => {
  const { user } = useAuth();
  const [activePage, setActivePage] = useState('dashboard');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const renderPage = () => {
    switch (activePage) {
      case 'dashboard':
        return <Dashboard />;
      case 'business':
        return <BusinessCollection />;
      case 'client':
        return <ClientManagement />;
      case 'system':
        return <SystemManagement />;
      case 'license':
        return <LicenseManagement />;
      case 'payment': 
        return <PaymentManagement />;
      case 'logs': 
        return <BusinessLogViewer />;
      default:
        return <Dashboard />;
    }
  };

  // Calculate sidebar width based on collapsed state
  const sidebarWidth = isSidebarCollapsed ? '5rem' : '16rem';

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Fixed Sidebar - positioned absolutely */}
      <Sidebar 
        activePage={activePage} 
        setActivePage={setActivePage}
        isCollapsed={isSidebarCollapsed}
        setIsCollapsed={setIsSidebarCollapsed}
      />
      
      {/* Fixed Navbar - positioned based on sidebar width */}
      <Navbar 
        activePage={activePage} 
        isSidebarCollapsed={isSidebarCollapsed}
      />

      {/* Main Content - positioned with margin based on sidebar width */}
      <main 
        className="min-h-screen transition-all duration-300 overflow-auto"
        style={{
          marginLeft: sidebarWidth,
          paddingTop: '4.5rem', // Adjust based on Navbar height
          paddingLeft: '1.5rem',
          paddingRight: '1.5rem',
          paddingBottom: '1.5rem'
        }}
      >
        {renderPage()}
      </main>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/*" element={<AdminLayout />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;